/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.health.assessments'},
});

const AssessmentsItem = () => (
  <RouteLinkItem
    route="midas/settings/health/assessments"
    title={messages.title}
  />
);

export default AssessmentsItem;
